import { api } from './client'
import type { CollaboratorPermission, InstitutionCollaborator } from '@/types/api'

export const COLLABORATOR_PERMISSIONS: Array<{
  value: CollaboratorPermission
  label: string
  description?: string
}> = [
  { value: 'campaigns.view', label: 'Visualizar campanhas' },
  {
    value: 'metrics.view',
    label: 'Visualizar dashboard e métricas',
    description: 'Inclui gráficos, KPIs, Páginas de origem e tabelas do dashboard da campanha.',
  },
  { value: 'customers.view', label: 'Visualizar clientes' },
  { value: 'orders.view', label: 'Visualizar pedidos' },
  { value: 'winners.view', label: 'Visualizar ganhadores' },
  { value: 'collaborators.manage', label: 'Gerenciar colaboradores' },
  { value: 'distributors.manage', label: 'Gerenciar distribuidores' },
]

export interface CollaboratorInput {
  name: string
  email: string
  password?: string
  permissions: CollaboratorPermission[]
  is_active: boolean
}

interface CollaboratorsResponse {
  collaborators: InstitutionCollaborator[]
}

interface CollaboratorResponse {
  collaborator: InstitutionCollaborator
}

export async function listCollaborators(): Promise<InstitutionCollaborator[]> {
  const response = await api.get<CollaboratorsResponse>(
    '/api/institution/collaborators',
    {
      requireAuth: true,
    }
  )
  return Array.isArray(response?.collaborators) ? response.collaborators : []
}

export async function createCollaborator(
  input: CollaboratorInput
): Promise<InstitutionCollaborator> {
  const response = await api.post<CollaboratorResponse>(
    '/api/institution/collaborators',
    input,
    { requireAuth: true }
  )
  return response.collaborator
}

export async function updateCollaborator(
  id: number,
  input: Partial<CollaboratorInput>
): Promise<InstitutionCollaborator> {
  const response = await api.put<CollaboratorResponse>(
    `/api/institution/collaborators/${id}`,
    input,
    { requireAuth: true }
  )
  return response.collaborator
}

export async function deleteCollaborator(id: number): Promise<void> {
  await api.delete(`/api/institution/collaborators/${id}`, { requireAuth: true })
}
